import { render, staticRenderFns } from "./SCG_7.vue?vue&type=template&id=260c1160&"
import script from "./SCG_7.vue?vue&type=script&lang=js&"
export * from "./SCG_7.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/kccp/PROD/kccp-portal-web-internet-dynamic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('260c1160', component.options)
    } else {
      api.reload('260c1160', component.options)
    }
    module.hot.accept("./SCG_7.vue?vue&type=template&id=260c1160&", function () {
      api.rerender('260c1160', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/request/new/SCG_7.vue"
export default component.exports